import { HomeOutlined } from "@ant-design/icons";
import { Home } from "../../../pages";
import routesMap from "../../../routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.HOME.path,
      name: "Home",
      key: routesMap.HOME.path,
      commonRoute: false,
      private: true,
      belongsToSidebar: true,
      icon: <HomeOutlined className="text-white" />,
      element: <Home />,
    },
  ];
}
